const LOGIN = 'LOGIN';
const LOGIN_FINISHED = 'LOGIN_FINISHED';
const LOGOUT = 'LOGOUT';
const REGISTER = 'REGISTER';
const CONFIRM = 'CONFIRM';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
const RESET_PASSWORD = 'RESET_PASSWORD';

export default {
	LOGIN,
	LOGIN_FINISHED,
	LOGOUT,
	REGISTER,
	CONFIRM,
	REFRESH_TOKEN,
	FORGOT_PASSWORD,
	RESET_PASSWORD,
};
